export const OAUTH_CREDENTIALS = {
  CLIENT_ID: '1',
  CLIENT_SECRET: 'bFnu0xsrYz0sUarXZFqUfHRuJMIAq4jV2iJBeAYu',
};

// To register
//php artisan passport:client --password
